import { useEffect, useState, useCallback } from "react";
import { isEqual, countBy } from "lodash";
import { useCustomerPermissionsRequests } from "../../../api/grpc/permissions/useCutomerPermissionRequests";
import { GetCustomerPermissionsResponse } from "../../../api/grpc/permissions/permissions";
import { useAuthContext } from "../../../lib/context/Auth/AuthContext";

export const useCustomerPermissions = () => {
  const { getCustomerPermissions } = useCustomerPermissionsRequests();
  const { updateUser, user } = useAuthContext();

  const [data, setData] = useState<GetCustomerPermissionsResponse | null>(null);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const fetchPermissions = useCallback(async () => {
    if (!user?.customerid || !user?.claims.user_id) return;

    try {
      setLoading(true);
      const { response } = await getCustomerPermissions({
        customerID: user.customerid,
        accountID: user.claims.user_id,
      });

      setData(response);

      if (response?.permissions) {
        const existingPermissions = user?.permissions || [];
        const hasChanged = !isEqual(
          countBy(existingPermissions),
          countBy(response.permissions)
        );
        const bookingChanged =
          user?.deskBookingEnabled !== response.deskBookingEnabled ||
          user?.roomBookingEnabled !== response.roomBookingEnabled;

        if (hasChanged || bookingChanged) {
          updateUser({
            permissions: response.permissions,
            deskBookingEnabled: response.deskBookingEnabled,
            roomBookingEnabled: response.roomBookingEnabled,
          });
        }
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [getCustomerPermissions, updateUser, user]);

  useEffect(() => {
    fetchPermissions();

    // Interval refetch every 3 minutes
    const intervalId = setInterval(fetchPermissions, 180000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  let isProPlan = data?.id?.toLowerCase()?.includes("pro");

  let isBussinesOrPro =
    data?.id?.toLowerCase()?.includes("business") ||
    data?.id?.toLowerCase()?.includes("pro");

  let isBasicOrBussines =
    data?.id?.toLowerCase()?.includes("business") ||
    data?.id?.toLowerCase()?.includes("basic");

  return {
    data,
    error,
    loading,
    refetch: fetchPermissions,
    isProPlan,
    isBussinesOrPro,
    isBasicOrBussines,
  };
};
